// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT!
/* tslint:disable */
export const APP_VERSION = '1.17.0';
export const APP_NAME = 'aboca-diario-alimentare';
export const FILE_HASH = '1588165264660';
export const BUILD_DATE = '2020-04-29T13:01:04.660Z';
/* tslint:enable */
